import {POI} from "../models/POI";
import { i18n } from "../../i18n";

export function createNewWaypointJsonHelper(lng: number, lat: number, title = i18n.global.t("utils.create_new_waypoint_json_helper.custom_waypoint"), type = POI.Other, description = "") {
  return {
    'lonlat': `POINT(${lng} ${lat})`,
    'title': title,
    'type': type,
    "description": description,
    "coordinateReferenceSystem": "EPSG:4326",
    "public": true
  }
}
